import React, { Component } from 'react';
import { LeftBlock, RightBlock } from './styled';

class DashBlock extends Component {

    render() {
        return this.props.right ? <RightBlock top={this.props.top}/> : <LeftBlock top={this.props.top}/>;
    }
}

export default DashBlock;
